import { Route } from '@angular/router';
import { RenderEngineComponent } from '@app/pages/render-engine/render-engine.component';
export const CATALOG_ROUTES: Route[] = [
  {
    path: '**',
    component: RenderEngineComponent,
  },
];

export const CATEGORY_ROUTE: Route[] = [
  {
    path: '',
    component: RenderEngineComponent,
    children: [
      {
        path: ':id',
        component: RenderEngineComponent,
      },
    ],
  },
];
